import CryptoJS from 'crypto-js';

const KEY = process.env.REACT_APP_KEY;
/**
 * @param {object} data
 * @param {string | object} data.value - encrypt value
 * @param {string | number} data.key - encrypt value
 * @param {boolean} data.stringify - JSON stringify
 * @return {string}
 */
export function encrypt({ value = '', key, stringify = true }) {
    const valueToEncrypt = typeof stringify === 'boolean' && stringify ? JSON.stringify(value) : value;
    return CryptoJS.AES.encrypt(valueToEncrypt, key || KEY).toString();
}

/**
 * @param {object} data
 * @param {string} data.value - decrypt value
 * @param {string | number} data.key - decrypt key
 * @param {boolean} data.parse - JSON parse
 * @return {string | boolean} Error if the return is false
 */
export function decrypt({ value = '', key, parse = true }) {
    if (!value) return false;
    const result = CryptoJS.AES.decrypt(value, key || KEY).toString(CryptoJS.enc.Utf8);
    if (typeof parse === 'boolean' && parse) {
        try {
            return JSON.parse(result);
        } catch (error) {
            console.error('Decrypt Error:', error);
            return false;
        }
    }
    return result;
}
